import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import useGetLogo from "./hooks/use-logo";
import favimage from "src/images/goodword-favicon.png";

const Logo = ({ disabledLink = false }) => {
  const logo = useGetLogo();

  if (disabledLink) {
    return (
      <img
        style={{ width: "150px", height: "250", maxHeight: "64px" }}
        src={favimage}
      />
    );
  }

  return (
    <RouterLink to="/">
      <img style={{ width: "450px", height: "auto" }} src={logo} />
    </RouterLink>
  );
};

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default Logo;
